export default "__VITE_ASSET__991278b8__"